import React from 'react';
import PropTypes from 'prop-types'
import styles from './PFSIcon.module.css';

import iconSvg from './pfs_icon.svg';

const PFSIcon = ({ imgSize = 52 }) => (
  <div className={styles.PFSIcon} data-testid="PFSIcon">
    <img
      alt="PFS Icon"
      src={iconSvg}
      height={imgSize}
      width={imgSize}
    />
  </div>
);

PFSIcon.propTypes = {
  imgSize: PropTypes.number,
};

export default PFSIcon;
